module.exports = __webpack_public_path__ + "media/images/illustrations/seniorCare-98e4ad1cc961c564df925c1cfb0a22fa.svg";